import { LockKeyhole } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { Button, Typography } from '../ui';
import styles from './BriefSlot.module.css';
import { upgradeHref } from '../../../lib/upgrade-origin';

// "Your agents have updates waiting" — the slot when the morning-brief routine is CREDIT-paused: the
// daily meeting is on hold until the account upgrades. A lock eyebrow ("Morning Meetings paused"), the
// Display-02 headline, a one-paragraph offer, and the standard credits upgrade CTA to the package
// picker — the same destination every credits CTA opens. Distinct from `ActivateBrief` (the user's own
// pause), whose "turn it on" ask would be a lie without credits. Figma node 2057:13349 ("Symphony Card
// Box"). Mirrors the native `BriefUpgradeCard`s.

export function UpgradeBrief() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();

  return (
    <section className={styles.slot} aria-labelledby="brief-upgrade-title">
      <p className={styles.eyebrow}>
        <LockKeyhole size={16} aria-hidden />
        <Typography variant="h4" color="strong" component="span">
          {t('brief.upgrade.eyebrow')}
        </Typography>
      </p>
      <h2 id="brief-upgrade-title" className={`${styles.title} ${styles.titleFirst}`}>
        {t('brief.upgrade.title')}
      </h2>
      <Typography variant="h3" component="p" className={styles.body}>
        {t('brief.upgrade.body')}
      </Typography>
      <div className={styles.actions}>
        <Button
          data-card-primary
          size="medium"
          href={upgradeHref('brief_upgrade')}
          onClick={() => {
            logPageClickBi({ page_name: 'home', button_name: 'brief_upgrade' });
          }}
        >
          {t('brief.upgrade.cta')}
        </Button>
      </div>
    </section>
  );
}
